import apiClient from "./apiClient";

const fetchDistricts = async () => {
  const response = await apiClient.get("/districts");
  return response.data._embedded.districts;
};

const createDistrict = async (district) => {
  const response = await apiClient.post("/districts", district);
  return response.data;
};
    
const fetchDistrictById = async (districtId) => {
  const response = await apiClient.get(`/districts/${districtId}?includeAllProps=true`);
  return response.data;
};

const fetchHospitalsByDistrictId = async (districtId) => {
  const response = await apiClient.get(
    `/districts/${districtId}/hospitals?includeAllProps=true`
  );
  return response.data._embedded.hospitals;
};

const fetchHospitals = async () => {
  const response = await apiClient.get("/hospitals");
  return response.data._embedded.hospitals;
};

export {
  fetchDistrictById,
  fetchDistricts,
  createDistrict,
  fetchHospitalsByDistrictId,
  fetchHospitals,
};